import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const travelGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // travelGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.TRAVEL) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const travelPlans = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // travelPlans is 2
    if (appID !== constAppID.TRAVEL) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'travelQuote' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const travelApplicant = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // travelApplicant is 3
    if (appID !== constAppID.TRAVEL) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'travelQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'travelQuotePlans' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const travelInsured = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // travelInsured is 4
    if (appID !== constAppID.TRAVEL) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 4) {
      if (quoteLifeCycle === 1) {
        next({ name: 'travelQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'travelQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'travelQuoteApplicant' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const travelPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // travelPayment is 5
    if (appID !== constAppID.TRAVEL) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 5) {
      if (quoteLifeCycle === 1) {
        next({ name: 'travelQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'travelQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'travelQuoteApplicant' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'travelQuoteInsured' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const travelPayment = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // travelPayment is 6
    if (appID !== constAppID.TRAVEL) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 6) {
      if (quoteLifeCycle === 1) {
        next({ name: 'travelQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'travelQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'travelQuoteApplicant' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'travelQuoteInsured' })
      } else if (quoteLifeCycle === 5) {
        next({ name: 'travelQuotePremium' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
